import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "M1.667 4.58a2 2 0 0 1 2-2h12.666a2 2 0 0 1 2 2v12.667a2 2 0 0 1-2 2H3.667a2 2 0 0 1-2-2V4.581z",
      stroke: "currentColor",
      "stroke-width": "1.2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.781 15.046c-.608 0-1.199-.08-1.77-.242-.565-.169-1.02-.385-1.365-.649l.605-1.342c.33.242.723.436 1.177.583.455.147.91.22 1.364.22.506 0 .88-.073 1.122-.22.242-.154.363-.356.363-.605a.552.552 0 0 0-.22-.45 1.507 1.507 0 0 0-.55-.298c-.22-.073-.52-.154-.902-.242a12.565 12.565 0 0 1-1.44-.418 2.383 2.383 0 0 1-.969-.67c-.264-.309-.396-.72-.396-1.233 0-.447.121-.85.363-1.21.242-.367.605-.656 1.09-.869.49-.213 1.088-.319 1.792-.319.492 0 .972.059 1.441.176.47.117.88.286 1.232.506l-.55 1.353c-.711-.403-1.422-.605-2.134-.605-.498 0-.869.08-1.11.242-.235.161-.353.374-.353.638s.136.462.407.594c.279.125.7.25 1.265.374.587.14 1.067.279 1.441.418.374.14.693.36.957.66.272.3.407.708.407 1.221 0 .44-.124.843-.374 1.21-.242.36-.608.645-1.1.858-.491.213-1.089.32-1.793.32zm4.364-6.05h1.716v5.918h-1.716V8.996zm.858-.825c-.315 0-.572-.092-.77-.275a.892.892 0 0 1-.297-.682c0-.271.099-.499.297-.682.198-.183.455-.275.77-.275s.572.088.77.264a.846.846 0 0 1 .297.66.952.952 0 0 1-.297.715c-.198.183-.455.275-.77.275z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }